import axios from 'axios';
import { ApiResult } from 'interfaces/APITypes';

import { buildAxiosResult } from 'utils/axios';

export const mytoverInstance = axios.create({
  baseURL: process.env.REACT_APP_MYTOVER_API,
  withCredentials: true,
});

export const makeRequest = async <T = any>(request: Promise<any>): Promise<ApiResult<T>> => {
  const response = await request;
  return (await buildAxiosResult(response)) as ApiResult<T>;
};
